/* eslint-disable jsx-a11y/anchor-has-content, jsx-a11y/anchor-is-valid, no-script-url */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export function HelpLink({
  query, children, className, ariaLabel, tabIndex,
}) {
  return (
    <a
      className={classNames('HelpTopic', className)}
      href="#"
      role="button"
      tabIndex={tabIndex}
      aria-label={ariaLabel}
      query={query}
      onClick={e => e.preventDefault()}
    >
      {children}
    </a>
  );
}

HelpLink.propTypes = {
  query: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
  ariaLabel: PropTypes.string,
  tabIndex: PropTypes.number,
};

HelpLink.defaultProps = {
  className: '',
  ariaLabel: '',
  tabIndex: undefined,
};

